import CitySEOHead from "@/components/feature/CitySEOHead";
import EdmondHeroSection from "./components/HeroSection";
import EdmondStickyNav from "./components/StickyNav";
import EdmondProcessingTimeSection from "./components/ProcessingTimeSection";
import EdmondServicesSection from "./components/ServicesSection";
import EdmondLocalAreaSection from "./components/LocalAreaSection";
import EdmondTravelTimingSection from "./components/TravelTimingSection";
import EdmondDestinationsSection from "./components/DestinationsSection";
import EdmondTestimonialsSection from "./components/TestimonialsSection";
import EdmondAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import EdmondComparisonSection from "./components/ComparisonSection";
import EdmondMistakesSection from "./components/MistakesSection";
import EdmondHowItWorksSection from "./components/HowItWorksSection";
import EdmondFAQSection, { faqs } from "./components/FAQSection";
import EdmondHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import EdmondFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for Edmond travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Edmond with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance for Edmond and UCO students with step-by-step guidance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "UCO Study Abroad Passport Processing", description: "Passport coordination for UCO students heading to Germany, Spain, and international study abroad programs." },
];

export default function EdmondPage() {
  return (
    <>
      <CitySEOHead
        city="Edmond"
        state="Oklahoma"
        stateAbbr="OK"
        route="/cities/edmond"
        title="Emergency Passport Edmond, OK — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Edmond, OK — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving UCO students, Edmond families, and north OKC metro professionals."
        geoPlacename="Edmond, Oklahoma"
        geoPosition="35.6528;-97.4781"
        faqs={faqs}
        servicesSchema={servicesSchema}
        statePageName="Oklahoma"
        statePageRoute="/states/oklahoma"
      />
      <div className="font-sans">
        <EdmondHeroSection />
        <EdmondStickyNav />
        <EdmondProcessingTimeSection />
        <EdmondServicesSection />
        <EdmondLocalAreaSection />
        <EdmondTravelTimingSection />
        <EdmondDestinationsSection />
        <EdmondTestimonialsSection />
        <EdmondAcceptanceFacilitiesSection />
        <EdmondComparisonSection />
        <EdmondMistakesSection />
        <EdmondHowItWorksSection />
        <EdmondFAQSection />
        <EdmondHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/edmond" state="OK" />
        <EdmondFinalCTA />
      </div>
    </>
  );
}